// oneXP feature flags
export const ABANDON_CART_FF = 'prebooking_abandon_cart';
export const DISABLE_PACKAGES_FF = 'prebooking_packages_tab_disabled';
export const EARLY_TENURE_FF = 'prebooking_early_tenure';
export const GET_INSPIRED_FF = 'prebooking_get_inspired';
export const PERSONA_API_FF = 'prebooking_homescreen_persona_api';
export const VACATION_RENTALS_FF = 'vr_prebooking_enabled_FF';

// oneXP experiments
export const MARKETING_TILES_EXPERIMENT = 'prebooking_home_mosaic_marketing_tiles';

// oneCMS feature flags
export const MOSAIC_SEARCH_WIDGET_FF = 'homepage_mosaic_search_widget';
